// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1yJtV","question":"styles_question__c7I_v","description":"styles_description__25Xkc"};